import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import InfiniteScroll from 'vue-infinite-scroll'
import Cube from 'cube-ui'
import VueClipboard from 'vue-clipboard2';

import '@/css/reset.css'
import '@/font/iconfont.css'
import 'weui';

Vue.use(InfiniteScroll)
Vue.use(Cube)
Vue.use(VueClipboard)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js